<template>
  <!-- <VView class="contest-game" back-button-to="/menu" :header="$t('contestGame.header')"> -->
  <VView class="contest-game">
    <VGame @end="onGameEnd($event)" />
  </VView>
</template>

<script>
import VGame from '@/games/pixi-custom/VGame.vue';
import { SET_ATTACHMENT, SET_SCORE } from '@/store';

export default {
  name: 'ContestGame',

  components: {
    VGame,
  },

  methods: {
    onGameEnd({ attachment, score }) {
      this.$store.commit(SET_ATTACHMENT, { attachment });
      this.$store.commit(SET_SCORE, { score });

      this.$router.push('/contest/results');
    },
  },
};
</script>

<style lang="scss" scoped>
.contest-game {
  ::v-deep .view__content {
    padding: 0;
  }
}
</style>
